import { Typography } from '@mui/material';
import MarkdownRenderer from '../renderers/MarkdownRenderer';

/**
 * Renders alternative view modes for a data note entry.
 * Returns null if viewMode is not handled here — caller renders iframe.
 * @param {object} entry
 * @param {string} viewMode
 */
export default function ViewModeRenderer({ entry, viewMode }) {
    if (viewMode === 'json')  return <MarkdownRenderer entry={entry} viewMode="json" />;
    if (viewMode === 'plain') return <Typography variant="body2" sx={{ color: 'var(--j-text)', whiteSpace: 'pre-wrap', fontSize: 13, p: 1 }}>{entry.body}</Typography>;
    if (viewMode === 'md')    return <MarkdownRenderer entry={entry} viewMode="md" />;

    return null;
}
